import { mapValues } from 'lodash';
import { z } from 'zod';

import { ImportRow } from '../loan/LoanImport';
import { CreateTransactionRowData } from '../loan/LoanTransaction';
import { TransferLoanRowData, TransferRevisionLoanRowData } from '../loan/LoanTransfer';
import { trimAndStrip } from '../validations/utils';
import { ConstructionToPermanentRowsPlatformData } from './FlatFilePlatformResponse';

export const ImportRowsData = z.strictObject({
  getRows: z.strictObject({
    data: z.array(
      z.strictObject({
        id: z.string(),
        // Use preprocessor to trim/strip nullish values into undefined
        mapped: z.preprocess((data: any) => mapValues(data, trimAndStrip), ImportRow),
        sequence: z.number(),
      }),
    ),
  }),
});
export type ImportRowsData = z.infer<typeof ImportRowsData>;

export const TransferRowsData = z.strictObject({
  getRows: z.strictObject({
    data: z.array(
      z.strictObject({
        id: z.string(),
        // Use preprocessor to trim/strip nullish values into undefined
        mapped: z.preprocess((data: any) => mapValues(data, trimAndStrip), TransferLoanRowData(true)),
        sequence: z.number(),
      }),
    ),
  }),
});
export type TransferRowsData = z.infer<typeof TransferRowsData>;

export const TransferRevisionRowsData = z.strictObject({
  getRows: z.strictObject({
    data: z.array(
      z.strictObject({
        id: z.string(),
        // Use preprocessor to trim/strip nullish values into undefined
        mapped: z.preprocess((data: any) => mapValues(data, trimAndStrip), TransferRevisionLoanRowData(true)),
        sequence: z.number(),
      }),
    ),
  }),
});
export type TransferRevisionRowsData = z.infer<typeof TransferRevisionRowsData>;

export const ConstructionToPermanentRowsData = z.strictObject({
  getRows: z.strictObject({
    data: ConstructionToPermanentRowsPlatformData,
  }),
});
export type ConstructionToPermanentRowsData = z.infer<typeof ConstructionToPermanentRowsData>;

// TODO
export const CreateTransactionRowsData = z.strictObject({
  getRows: z.strictObject({
    data: z.array(
      z.strictObject({
        id: z.string(),
        // Use preprocessor to trim/strip nullish values into undefined
        mapped: z.preprocess((data: any) => mapValues(data, trimAndStrip), CreateTransactionRowData),
        sequence: z.number(),
      }),
    ),
  }),
});
export type CreateTransactionRowsData = z.infer<typeof CreateTransactionRowsData>;

export const FlatFileErrors = z.object({
  errors: z
    .object({
      message: z.string(),
    })
    .array(),
});
export type FlatFileErrors = z.infer<typeof FlatFileErrors>;

export const ImportResponse = ImportRowsData.or(FlatFileErrors);
export type ImportResponse = z.infer<typeof ImportResponse>;

export const TransferResponse = TransferRowsData.or(FlatFileErrors);
export type TransferResponse = z.infer<typeof TransferResponse>;

export const ConstructionToPermanentResponse = ConstructionToPermanentRowsData.or(FlatFileErrors);
export type ConstructionToPermanentResponse = z.infer<typeof ConstructionToPermanentResponse>;
